import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import Vue from 'vue';
import uploader from "lib/mixins/uploader";
import PreparingCourseware from "../PreparingCourseware.vue";
export default {
  name: "oss-question-file",
  components: {
    PreparingCourseware: PreparingCourseware
  },
  mixins: [uploader],
  props: {
    fileIds: {
      type: Array,
      default: ""
    },
    filesList: {
      type: Array,
      default: {
        Id: String,
        DocTitle: String,
        DocUrl: String,
        DownloadUrl: String
      }
    },
    IsUpload: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    var _this = this;

    // this.questionFiles = [];
    var list = [];
    this.filesList.forEach(function (element) {
      list.push({
        name: element.DocTitle,
        url: element.DocUrl,
        docId: element.Id,
        downloadUrl: element.DownloadUrl == undefined ? "" : element.DownloadUrl
      }); // this.fileIds.push(element.Id);
    });
    this.$nextTick(function () {
      _this.questionFiles = list;
    });
  },
  data: function data() {
    return {
      questionFiles: [],
      sourceUrl: {
        id: "",
        url: "",
        type: "",
        docName: "",
        docType: 0
      },
      docId: "",
      dialogVisiblePreviewResources: false
    };
  },
  watch: {
    filesList: function filesList(val) {
      var _this2 = this;

      // this.questionFiles = [];
      var list = [];
      val.forEach(function (element) {
        list.push({
          name: element.DocTitle,
          url: element.DocUrl,
          docId: element.Id,
          downloadUrl: element.DownloadUrl == undefined ? "" : element.DownloadUrl
        }); // this.fileIds.push(element.Id);
      });
      this.$nextTick(function () {
        _this2.questionFiles = list;
      });
    }
  },
  methods: {
    beforeUpload: function beforeUpload(file) {
      return this.addFile(file);
    },
    onRemoveHandler: function onRemoveHandler(file) {
      // if (this.onRemove) {
      //   this.onRemove();
      // }
      this.questionFiles = this.questionFiles.filter(function (p) {
        return p.docId !== file.docId;
      }); // this.fileIds.splice(this.fileIds.indexOf(file.docId), 1);

      this.fileIds = this.fileIds.filter(function (p) {
        return p !== file.docId;
      });
      this.$emit("update:fileIds", this.fileIds);
    },
    beforeRemove: function beforeRemove(file, fileList) {
      return this.$confirm("\u786E\u5B9A\u79FB\u9664 ".concat(file.name, "\uFF1F"));
    },
    dialogClose: function dialogClose() {
      this.dialogVisiblePreviewResources = false;
    },
    handlePreview: function handlePreview(docId) {
      this.dialogVisiblePreviewResources = true;
      this.docId = docId; // GetFileInfo(docId).then(rst => {
      //   if (rst.status == -1) {
      //     this.$message.warning("文件转换失败不能预览");
      //   } else if (rst.status == -2) {
      //     this.$message.warning("文件正在转换请稍后预览");
      //   } else if (rst.status == 1) {
      //     this.sourceUrl = {
      //       url: rst.docPriviewUrl,
      //       type: rst.type,
      //       docName: rst.docName,
      //       docType: rst.docType,
      //       id:file.docId
      //     };
      //   } else {
      //     this.$message.warning(rst.msg);
      //   }
      // });
    },
    onSuccessHandler: function onSuccessHandler(res, file, uploadFiles) {
      // 执行mixins里的onSuccess, 继续下一个文件
      if (this.onSuccess) {
        this.onSuccess(res, file, uploadFiles);
      }

      if (res.code > 0) {
        file.url = res.docPath;
      }

      this.questionFiles.push({
        name: file.name,
        url: res.docPath,
        docId: res.docId
      }); // this.fileIds.push(res.docId);

      this.$emit("update:fileIds", this.fileIds);
    }
  }
};